import React from "react";


function Dashboard() {


  return (
    <h1>Coming Soon</h1>
  );
}

export default Dashboard;